import React from 'react';
import { PatientDetails } from './PatientDetailsConstant';
import Avatar from '../../../../../components/base/Avatar/Avatar';
import { Spinner } from 'react-bootstrap';

interface PatientInfoProps {
  patientData: PatientDetails;
  isLoading: boolean;
  isDirectoryPlatform: boolean;
}

const PatientInfo: React.FC<PatientInfoProps> = ({
  patientData,
  isLoading,
  isDirectoryPlatform,
}) => {
  return (
    <div className="details-card patient-info-card">
      {isLoading ? (
        <div className="loader-container">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <div className="info-header">
            <div className="patient-avatar">
              <Avatar
                fullName={patientData.name}
                photoUrl={patientData.photoUrl}
                size="36px"
              />
            </div>
            <div className="patient-summary">
              <div className="patient-name">{patientData.name}</div>
              <div className="patient-phone">{patientData.phone}</div>
            </div>
            {/* NOTE: Will add this link later MVP release */}
            {/* <a className="add-card-link">+ Add a card</a> */}
          </div>
          <div className="balance-info">
            <div
              className={`balance-item ${
                isDirectoryPlatform ? 'left' : 'center'
              }`}
            >
              <div className="balance-label">{isDirectoryPlatform ? 'Provider' : 'Patient'} Balance</div>
              <div className="balance-amount">
                ${patientData.patientBalance}
              </div>
            </div>
            {!isDirectoryPlatform && (
              <div className="balance-item center">
                <div className="balance-label">Insurance Balance</div>
                <div className="balance-amount">
                  ${patientData.insuranceBalance}
                </div>
              </div>
            )}
            {!isDirectoryPlatform && (
              <div className="balance-item center">
                <div className="balance-label">Total Balance</div>
                <div className="balance-amount">
                  ${patientData.totalBalance}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PatientInfo;
